import Component from './Mobile'

export default Component
